import { css } from "@emotion/react";

import { COLORS } from "../../stylesheets/emotion/vars";
import image from "../images/mississippi/mississippi-pattern.png";

export const missouriStyleVertical = css`
    body {
        overflow-y: scroll;
        scrollbar-width: none;
        -ms-overflow-style: none;
        &::-webkit-scrollbar {
            width: 0;
            height: 0;
        }
    }

    .bannerAll {
        display: grid;
        grid-template-columns: auto auto auto;
        margin-bottom: 1vw;
    }
    .bannerBack {
        width: 18.5%;
        margin-top: 1vw;
        position: absolute;
        margin-left: 53.6%;
    }
    .bannerFront {
        width: 20%;
        margin-left: 26.4%;
        margin-top: 1vw;
        position: absolute;
    }
    .bannerLogo {
        width: 4.5vw;
        position: relative;
        margin-top: 0.1vw;
        margin-bottom: 1.5vw;
        margin-left: 131.2%;
        z-index: 1000;
    }

    @keyframes rotation {
        0% {
            transform: rotate(0deg) scale(0.5);
            opacity: 0.15;
        }
        5% {
            transform: rotate(180deg) scale(0.5);
            opacity: 0.3;
        }
        10% {
            transform: rotate(360deg) scale(0.5);
            opacity: 0.15;
        }
        100% {
            transform: rotate(360deg) scale(0.5);
            opacity: 0.15;
        }
    }
    @keyframes opacity {
        0% {
            opacity: 0.05;
        }
        50% {
            opacity: 0.2;
        }
        100% {
            opacity: 0.05;
        }
    }

    .menukaart {
        width: 100vw;
        height: 177.78vw; /* 16:9 ratio */
        display: grid;
        grid-template-columns: auto auto auto;
        position: relative;
    }

    .menu {
        width: 46.5vw;
        height: 46.5vw;
        margin-left: 2vw;
        margin-top: 2vw;
        position: relative;
    }

    .backgroundShadow {
        background-color: rgba(0, 0, 0, 0.6);
        border-radius: 15px;
    }

    .info {
        display: flex;
        flex-direction: row-reverse;
        max-height: 1vh;
    }
    .row {
        display: flex;
        padding-block: 0.1vw;
        padding-top: 0vw;
        background-color: rgba(50, 50, 50, 0.1);
    }
    .row:nth-child(even) {
        background-color: rgba(0, 0, 0, 0.5);
    }
    .row:nth-last-child(1) {
        border-bottom-left-radius: 1vw;
        border-bottom-right-radius: 1vw;
    }
    .rowContent {
        padding: 0.22vw 0;
        display: flex;
    }

    .productkind {
        color: white;
        font-size: 0.9vw;
        margin-top: 0.3vw;
        width: 3vw;
        margin-left: 2vw;
    }
    .banner {
        width: 100%;
        margin-left: 8vw;
        margin-top: 1vw;
        position: relative;
    }

    .pagebackground {
        background-color: ${COLORS.pricelistBackgroundColor};
        background-repeat: no-repeat;
        background-size: cover;
        width: 100vw;
    }
    .pattern {
        background-image: url("${image}");
        background-size: 100% 70%;
        position: absolute;
        margin-left: -3%;
        top: -8%;
        height: 300vw;
        margin-top: -39%;
        width: 20%;
        opacity: 0.1;
        animation: opacity 10s 1s;
        animation-delay: 0s;
        animation-iteration-count: infinite;
    }
    .redbg {
        position: absolute;
    }
    @font-face {
        font-family: "cordia";
        font-weight: normal;
        font-style: normal;
    }

    .logo {
        position: absolute;
        margin-left: 15.2%;
        margin-top: 40%;
        width: 70%;
        opacity: 0.2;
        animation: rotation 25s 20s;
        animation-delay: 0s;
        animation-iteration-count: infinite;
    }

    .marginTopTitle {
        margin-top: -4vw;
    }

    .title {
        margin-left: 1.5vw;
        font-size: 2.5vw;
        font-weight: 600;
        margin-top: 1vw;
        margin-bottom: 0.1vw;
        position: relative;
        width: 24vw;
        color: white;
        text-shadow: 2px 2px #000000;
    }
    .titleNotAtTop {
        margin-left: 1.5vw;
        font-size: 2.5vw;
        font-weight: 600;
        margin-top: 1vw;
        margin-bottom: 0.2vw;
        position: relative;
        width: 24vw;
        color: white;
        text-shadow: 2px 2px #000000;
    }
    .particles {
        position: absolute;
        margin-left: 50vw;
        width: 300px;
    }
    .btn {
        position: absolute;
    }
    .kindBadge {
        margin: auto;
        padding: 0 0.75vw;
        //Padding between badge and namePrice
    }
    .nameStar {
        display: flex;
    }
    .newBadge {
        margin-top: 0.1vw;
        scale: 1.5;
        transform: translateY(-0.2vw);
    }
    .nameprice {
        font-size: 1.7vw;
        text-transform: uppercase;
        color: white;
        font-weight: 600;
        padding-block: 0.5vw;
        margin-top: 0vw; // Fix for font being a little bit up
    }
    .description {
        font-size: 1.4vw;
        color: ${COLORS.descriptionColor};
        margin: 0 auto;
        display: none;
    }
    .kind {
        font-size: 0.5vw;
        position: relative;
        margin-left: -2vw;
        margin-top: 0.5vw;
        width: 5vw;
        color: white;
    }
    .priceContainer {
        position: relative;
        right: 0.7vw;
        margin-right: 0.2vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: right;
    }
    .price {
        font-size: 1.6vw;
        width: 5.5vw;
        color: white;
        text-align: right;
    }
    .oldPrice {
        font-size: 1vw;
        text-shadow: #bfbfa6 0.1vw 0.1vw;
        width: 5.5vw;
        color: grey;
        z-index: 1;
        text-decoration: line-through;
    }
    .discountedPrice {
        font-size: 1.6vw;
        text-shadow: #bfbfa6 0.1vw 0.1vw;
        width: 5.5vw;
        color: red;
        font-weight: bold;
        z-index: 1;
    }
    .priceHeader {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        font-size: 1.5vw;
        margin-top: -2.5vw;
        width: 5.6vw;
        color: white;
        line-height: 0.9;
        margin-bottom: 0.8vw;
    }

    .priceHeader .amount {
        font-size: 1.6vw;
        font-weight: 800;
    }

    .priceHeader .unit {
        font-size: 1.4vw;
        text-transform: uppercase;
    }

    .filler {
        flex-grow: 1;
    }
    .svg-inline--fa {
        margin-left: 20px;
        margin-top: 8px;
        font-size: 30px;
    }

    .legend {
        position: absolute;
        z-index: 100;
    }
    .legendNew {
        display: none;
    }
    .legendContainer {
        position: relative;
        padding: 15px;
        width: 90vw;
        background-color: rgba(175, 175, 175, 0.7);
        border-radius: 15px;
        display: flex;
        justify-content: center;
    }

    .priceGrid {
        display: flex;
        justify-content: center;
    }
`;
